import React, { useEffect, useRef } from 'react'
import {useNavigate} from "react-router-dom";
import "./style.css";
import { Button, GhostButton } from '../Button/Button';
import { RxArrowTopRight } from "react-icons/rx";
import { Reveal } from '../Reveal/Reveal';
import lottie from "lottie-web";

export const Banner = (prop) => {
  const navigate = useNavigate();

  const container  = useRef(null);
  useEffect(() => {
    container.current.innerHTML = '';
    lottie.loadAnimation({
      container: container.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: require("../../Assets/lap.json")
    })
  }, [container]);

  return (
    <section className='banner-container container-style'>
      <div className='content-sizing banner-wrapper'>
        <div className='left-side-banner-container'>
          
          <Reveal delay={.1}><span className='small-tag'>INNOVATION & QUALITY</span></Reveal>
          <Reveal delay={.2}>
            <div className='banner-text'>
              <h1>Tailored
                <div>
                  <ul>
                    <li>Web</li>
                    <li>Software</li>
                    <li>Mobile</li>
                    <li>Cloud</li>
                    <li>IT</li>
                  </ul> 
                </div>
              Solutions for your business</h1>
            </div>
          </Reveal>

          <Reveal delay={.3}><p  className='banner-para'>Crafting custom software, dynamic web apps, and strategic IT consulting for your digital success.</p></Reveal>
          <Reveal delay={.4}>
            <div className='banner-action-button'>
              <Button onClick={() => navigate("/about-us")}>Learn More</Button>
              <GhostButton onClick={() => prop.setIsOpen(true)}>Let's Talk <RxArrowTopRight/></GhostButton>
            </div>
          </Reveal>
        </div>
        

        <div className='banner-image'>
          <Reveal delay={.3}>
            {/* <div className='cover-image'>
              <Reveal delay={.4}>
                <div className='single-card-box-banner'>
                    <i className="bi bi-star-fill"></i>
                    <div className='right-side-banner-info'>
                      <span>Reviews</span>
                      <p>100+ Reviews</p>
                    </div>
                  </div>
                
              </Reveal>
              <div className='col-2-banner'>
                <Reveal delay={.5}>
                  <div className='single-card-box-banner'>
                    <img src={google}/>
                    <div className='right-side-banner-info'>
                      <span>Verified</span>
                      <p>Google Approved</p>
                    </div>
                  </div>
                </Reveal>

                <Reveal delay={.6}>
                <div className='single-card-box-banner'>
                  <h3>+8</h3>
                  <div className='right-side-banner-info'>
                    <span>Years</span>
                    <p>Experience</p>
                  </div>
                </div>
                </Reveal>
              </div>
            </div> */}
            <div className='container-banner-right-side' ref={container}></div>
          </Reveal>
        </div>
      </div>
    </section>
  )
}
